import React, { FC, useEffect } from 'react';
import { IconEnum } from '@investoro/core';
import styled from 'styled-components';

import Button from 'components/atom/Button';

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    padding: 20px;
`;

const Card = styled.div`
    background: var(--color-white);
    border-radius: 10px;
    padding: 40px;
    max-width: 600px;
    width: 100%;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
    font-size: 24px;
    margin-bottom: 20px;
    color: var(--color-primary);
    font-weight: 600;
`;

const Message = styled.p`
    font-size: 14px;
    margin: 30px 0 50px;
    line-height: 1.5;
    color: var(--color-primary-80);
`;

const OrderDetails = styled.div`
    background: var(--color-alt-second);
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 30px;
    text-align: left;
`;

const OrderItem = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
    
    &:last-child {
        margin-bottom: 0;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 50px;
`;

const StyledButton = styled(Button)`
    padding: 15px 30px !important;
    min-width: 150px;
`;

const Przelewy24Page: FC = () => {
    useEffect(() => {
        const isPopup = window.opener !== null || window.name === 'popup' || window.outerHeight < screen.availHeight;

        if (isPopup) {
            window.close();
        }
    }, []);

    const handleCloseWindow = () => {
        window.close();
    };

    return (
        <PageContainer>
            <Card>
                <Title>Zamknij kartę</Title>

                <Message>
                    Zamknij tę kartę i wróć do aplikacji. <br/> Informacje o statusie płatności znajdziesz w głównej aplikacji.
                </Message>

                <OrderDetails>
                    <OrderItem>
                        <span>Data transaksji:</span>
                        <span>{new Date().toLocaleDateString()}</span>
                    </OrderItem>
                </OrderDetails>
                <ButtonContainer>
                    <StyledButton
                        onClick={handleCloseWindow}
                        actionIconVisible={false}
                        important
                        icon={IconEnum.CROSS}>
                        Zamknij
                    </StyledButton>
                </ButtonContainer>

            </Card>
        </PageContainer>
    );
};

export default Przelewy24Page;
